"use strict";
exports.__esModule = true;
var AutocompleteSizes;
(function (AutocompleteSizes) {
    AutocompleteSizes[AutocompleteSizes["Small"] = 0] = "Small";
    AutocompleteSizes[AutocompleteSizes["Default"] = 1] = "Default";
})(AutocompleteSizes = exports.AutocompleteSizes || (exports.AutocompleteSizes = {}));
exports.getMaxSuggestions = function (size) {
    switch (size) {
        case AutocompleteSizes.Small:
            return 3;
        case AutocompleteSizes.Default:
        default:
            return 5;
    }
};
